// apiCustomers.ts

import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

// Customer APIs
export async function getCustomers() {
  const headersList = {
    Accept: '*/*',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  };

  const reqOptions = {
    url: `${backendUrl}/api/customers`,
    method: 'GET' as const,
    headers: headersList,
  };

  const { data } = await axios.request(reqOptions);
  console.log(data)
  return data;
}

export async function deleteCustomer(id: number) {
  const headersList = {
    Accept: '*/*',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  };

  const reqOptions = {
    url: `${backendUrl}/api/customers/${id}`,
    method: 'DELETE' as const,
    headers: headersList,
  };

  const { data } = await axios.request(reqOptions);
  return data;
}

export async function addCustomer(
  name: string,
  operator_number: string,
  water_source: string,
) {
  const headersList = {
    Accept: '*/*',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  };

  const bodyContent = JSON.stringify({
    name,
    operator_number,
    water_source,
  });

  const reqOptions = {
    url: `${backendUrl}/api/customers`,
    method: 'POST' as const,
    headers: headersList,
    data: bodyContent,
  };

  const { data } = await axios.request(reqOptions);
  return data;
}

export async function editCustomer(
  id: number,
  name: string,
  operator_number: string,
  water_source: string,
) {
  const headersList = {
    Accept: '*/*',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  };

  const bodyContent = JSON.stringify({
    name,
    operator_number,
    water_source,
  });

  const reqOptions = {
    url: `${backendUrl}/api/customers/${id}`,
    method: 'PUT' as const,
    headers: headersList,
    data: bodyContent,
  };

  const { data } = await axios.request(reqOptions);
  return data;
}

// User-Customer Association APIs
export async function addUsersToCustomer(customerId: number, userIds: string[]) {
  const headersList = {
    Accept: '*/*',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  };

  const bodyContent = JSON.stringify({
    user_ids: userIds,
  });

  const reqOptions = {
    url: `${backendUrl}/api/customers/${customerId}/users`,
    method: 'PUT' as const,
    headers: headersList,
    data: bodyContent,
  };

  const { data } = await axios.request(reqOptions);
  return data;
}

export async function removeUsersFromCustomer(customerId: number, userIds: string[]) {
  const headersList = {
    Accept: '*/*',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  };

  const bodyContent = JSON.stringify({
    user_ids: userIds,
  });

  const reqOptions = {
    url: `${backendUrl}/api/customers/${customerId}/users`,
    method: 'DELETE' as const,
    headers: headersList,
    data: bodyContent,
  };

  const { data } = await axios.request(reqOptions);
  return data;
}

export async function getCustomerUsers(customerId: number) {
  const headersList = {
    Accept: '*/*',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  };

  const reqOptions = {
    url: `${backendUrl}/api/customers/${customerId}/users`,
    method: 'GET' as const,
    headers: headersList,
  };

  const { data } = await axios.request(reqOptions);
  return data;
}
